<template>
  <div class="lpo-data">
    <LpoDataSidebar />

    <div class="lpo-data__content">
      <template v-if="currentLpo && !currentLpoLoading">
        <div class="content-wrapper">
          <router-view />
          <div class="test" v-if="!actLpoIsDraft">
            <fa-icon icon="lock" class="test-icon" />
            <div>Акт в режиме чистовика</div>
            <div>Для внесения изменений переведите акт в режим черновика</div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="lpo-data__content-block">
          <p-spinner stroke-width="5" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import LpoDataSidebar from "./LpoData__sidebar";

export default {
  name: "SelectedLpoData",
  components: {
    LpoDataSidebar,
  },

  beforeRouteUpdate(to, from, next) {
    /* если сменилось обследование, то его нужно перезагрузить */
    if (from.params.lpo_id !== to.params.lpo_id) {
      this.clearCurrentLpoData();
      this.getCurrentLpoData(to.params.lpo_id);
    }

    next();
  },

  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    ...mapState("lpoData", {
      currentLpo: (state) => state.currentLpo,
      currentLpoLoading: (state) => state.currentLpoLoading,
    }),
  },

  methods: {
    ...mapMutations("lpoData", ["clearCurrentLpoData"]),

    ...mapActions("lpoData", ["getCurrentLpoData"]),

    ...mapActions("currentLpo", ["getCurrentLpo"]),
  },

  created() {
    console.log('lpo_data_mounted')
    const lpo_id = this.$route.params["lpo_id"];

    this.getCurrentLpo(lpo_id); 
    this.getCurrentLpoData(lpo_id);
  },

  beforeDestroy() {
    this.clearCurrentLpoData();
  },
};
</script>

<style scoped>
.test {
  padding: 0.5rem;
  color: white;
  font-size: 1.2rem;
  text-align: center;
  background-color: rgba(100, 100, 100, 0.5);
  position: sticky;
  bottom: 0;
}

.test-icon {
  position: absolute;
  top: 21px;
  right: 21px;
}
</style>

<style scoped>
.lpo-data {
  display: flex;
  height: 100%;
}

.lpo-data__content {
  flex: 1;
  height: 100%;
  overflow-y: auto;
}

.lpo-data__content-block {
  background-color: rgba(180, 180, 180, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.lpo-data__content-block .p-progress-spinner {
  height: 50px;
  width: 50px;
}
</style>
